import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  loadDataReportVoucherHolders,
  clearState,
  reportVoucherHolders,
  exportReportsVoucherHolder
} from './ReportVoucherHoldersDucks';
import useTableFilter from '../../../components/TableFilter/useTableFilter';
import Paper from '@material-ui/core/Paper';
import StaticTablePagination from '../../../_ui/Table/StaticTablePaginated';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Popper from '@material-ui/core/Popper';
import { reportsVoucherHoldersColumns } from './ReportsVoucherHoldersColumns';
import Button from '../../../_ui/Button/Button';
import ExportIcon from '@material-ui/icons/SaveAlt';

const SERVICE_TYPE_OPTIONS = [
  { code: 'WAITING_PO', labelKey: 'monitoring_reportVoucherHoldersWaitingForPO' },
  { code: 'NOT_SELECT_PO', labelKey: 'monitoring_reportVoucherHoldersNotSelectPO' },
  { code: 'NOT_ACCEPT_VOUCHER', labelKey: 'monitoring_reportVoucherHoldersNotAcceptVoucher' }
];

function ReportsVoucherHolders() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { tableData, loadingTable } = useSelector(state => state[reportVoucherHolders]);

  const [reportVoucherHoldersType, setReportVoucherHoldersType] = useState(SERVICE_TYPE_OPTIONS[0]);
  const loadVoucherHoldersData = (filter) => {
    let requestFilter = { ...filter };
    if (reportVoucherHoldersType.code === 'WAITING_PO') {
      return dispatch(loadDataReportVoucherHolders(requestFilter));
    }
    if (reportVoucherHoldersType.code === 'NOT_SELECT_PO') {
      requestFilter.appStatus = 'ASSIGN_VOUCHER';
      return dispatch(loadDataReportVoucherHolders(requestFilter, 'NOT_SELECT_PO'));
    }
    if (reportVoucherHoldersType.code === 'NOT_ACCEPT_VOUCHER') {
      requestFilter.appStatus = ['ANNULLED', 'REJECTED_VOUCHER'];
      return dispatch(loadDataReportVoucherHolders(requestFilter, 'NOT_ACCEPT_VOUCHER'));
    }
  };



  const { nextPage, reloadForReportsVoucherHolders } = useTableFilter(
    loadVoucherHoldersData,
    {
      pageNumber: 1,
      pageSize: 10
    },
    ''
  );

  useEffect(() => {
    dispatch(clearState());
    reloadForReportsVoucherHolders();
  }, [dispatch, reportVoucherHoldersType]);

  return (
    <Paper className="pb3 pt1 px3">
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
        <Autocomplete
          style={{ width: 350 }}
          placeholder={t('monitoring_columnService')}
          fullWidth
          value={reportVoucherHoldersType}
          disableClearable
          PopperComponent={props => (
            <Popper {...props} style={{ ...props.style, minWidth: 400 }} />
          )}
          onChange={(ev, option) => {
            setReportVoucherHoldersType(option);
          }}
          options={SERVICE_TYPE_OPTIONS}
          getOptionLabel={option => t(option.labelKey)}
          renderInput={params => (
            <TextField
              {...params}
              label={t('monitoring_columnService')}
              InputProps={{
                ...params.InputProps,
                readOnly: true
              }}
            />
          )}
        />

        <Button
          text={t('monitoring_export_btn')}
          icon={<ExportIcon fontSize="small" className="mr1" />}
          onClick={() => dispatch(exportReportsVoucherHolder(reportVoucherHoldersType.code))}
        />
      </div>

      <StaticTablePagination
        columns={reportsVoucherHoldersColumns({
          t,
          reportVoucherHoldersType
        })}
        data={tableData.content}
        sortable={false}
        loading={loadingTable}
        totalElements={tableData.totalElements}
        onClickLoadMore={() => nextPage()}
      />
    </Paper>
  );
}

export default ReportsVoucherHolders;